export default "__VITE_ASSET__3e09cf1a__"